module.exports = __webpack_public_path__ + "img/user-sample.fb3413be.jpg";